import { api } from "../../api";

export const mapApi = api.injectEndpoints({
  tagTypes: ["Map"],
  endpoints: (builder) => ({
    getDistance: builder.mutation({
      query(body) {
        return {
          url: "/maps/distance",
          method: "POST",
          body,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetDistanceMutation } = mapApi;
